import * as React from 'react';
import Blob from '../Blob/Blob.esm.js';
import classNames from 'classnames';
import 'react-autosuggest';
import '@invitae/ids-react';
import 'tslib';
import '../../../../common/VideoPopupLink/VideoPopup/VideoPopup.esm.js';
import '@invitae/add-to-cart';
import '@invitae/nucleobase-engine-contentful';
import '../../../../contexts/GlobalActionsContext/GlobalActionsContext.esm.js';
import '@invitae/nucleobase-analytics';
import '../../../../common/ContentfulImage/ContentfulImage.esm.js';
import '../../../../hooks/animation/animationContext.esm.js';
import '../../../../hooks/animation/classManipulation.esm.js';
import '../../../../types/animation.esm.js';
import '../../../../common/ContentfulImage/ImageContext.esm.js';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import WrappedVideo from '../../../../common/WrappedVideo/WrappedVideo.esm.js';
import '../../../../common/WrappedVideo/NvVideo/NvVideo.esm.js';
import NvVimeo from '../../../../common/WrappedVideo/Vimeo/Vimeo.esm.js';
import 'react-dom';
import 'luxon';
import 'use-debounce';
import '../../../../GlobalTextCopyContext/GlobalTextCopyContext.esm.js';
import { useContentfulMedia } from '../../../../hooks/useContentfulMedia.esm.js';
import styles from './MediaWrapper.module.esm.js';

var MediaWrapper = function (_a) {
    var _b;
    var theme = _a.theme, vimeoId = _a.vimeoId, image = _a.image, media = _a.media;
    var videoFields = useContentfulMedia(media).videoFields;
    if (!vimeoId && !image && !videoFields && !image)
        return null;
    return (React.createElement("div", { className: styles.mediaContainer },
        React.createElement("div", { className: styles.blob },
            React.createElement(Blob, { theme: theme })),
        React.createElement("div", { className: classNames(styles.media, (_b = {}, _b[styles.mediaVideo] = !!videoFields, _b)) },
            !!image && React.createElement(BaseNucleobaseComponent, { alt: "", classes: { picture: styles.picture }, source: image }),
            !!vimeoId && !videoFields && React.createElement(NvVimeo, { vimeoId: vimeoId }),
            !vimeoId && !!videoFields && React.createElement(WrappedVideo, { fields: videoFields, id: "" }))));
};

export { MediaWrapper };
//# sourceMappingURL=MediaWrapper.esm.js.map
